import { useDispatch } from "react-redux"
import styled from "styled-components"
import InputDate from "../shared/input/new/InputDate"
import { useSelector } from "react-redux"
import { sendTargetDateNotification, setTargetDate } from "../../features/admin4/admin4Slice"
import getTargetDate from "../../helper/notification/getTargetDate"
import TimeInput from "../shared/input/notification/TimeInput"
import Btn from "../shared/button/Btn"
import SmallSpinner from "../shared/spinners/SmallSpinner"

const Container = styled.div`
    width: auto;
    display: flex;
    height: auto;
    gap: 20px;
    flex-direction: column;
`

const TargetDateNotificationContainer = ({isAll}) => {

  const dispatch = useDispatch()

  const {
    targetDate,
    timeData,
    notificationMenu,
    notificationSubMenu,
    selectedPhoneNumbers,
    notificationTitle,
    notificationText,
    mobileNotification,
    isLoadingSendTargetDateNotification
  } = useSelector(state => state.admin4)

  const handleClick = () => {

    if(!isAll){

      if(timeData.minute && timeData.hour && notificationMenu.value && targetDate && selectedPhoneNumbers.length > 0 && notificationTitle && notificationText){
        
        const body = {
            scheduledTime: getTargetDate({dateString:targetDate, hour: timeData.hour, minute: timeData.minute}),
            isEveryone: false,
            isMobileUser: true,
            title: notificationTitle,
            text:  notificationText,
            screenName: notificationSubMenu.value,
            routeName:notificationMenu.value,
            notificationAdded: mobileNotification,
            scheduledNotificationRecipients: selectedPhoneNumbers.map(item => {
              return {
                  phoneNumber: item.phoneNumber
              }
          })
        }

        dispatch(sendTargetDateNotification(body))
        
      }

    }

    else{

      if(timeData.minute && timeData.hour && notificationMenu.value && targetDate && notificationTitle && notificationText){
        
        const body = {
            scheduledTime: getTargetDate({dateString:targetDate, hour: timeData.hour, minute: timeData.minute}),
            isEveryone: true,
            isMobileUser: true,
            title: notificationTitle,
            text:  notificationText,
            screenName: notificationSubMenu.value,
            routeName:notificationMenu.value,
            notificationAdded: mobileNotification,
        }
        dispatch(sendTargetDateNotification(body))
      }
    }
}


  return (
    <Container>
        <InputDate labelText={"Bildirim Gönderim Tarihi Seçiniz"} data={targetDate} setData={(e) => dispatch(setTargetDate(e.target.value))} inputWidth={"362px"}/>
        <TimeInput inputWidth={"362px"}/>
        <Btn bgColor="var(--color-main)" color="#fff" handleClick={handleClick} width={"250px"}>{isLoadingSendTargetDateNotification ? <SmallSpinner size={"10px"} color={"#fff"} bgColor={"#E85446"}/> : "Bildirim Gönder"}</Btn>
        
    </Container>
  )
}

export default TargetDateNotificationContainer